<template>
  <div class="position-relative">
    <!-- ローディングオーバーレイ -->
    <div v-if="l_map_overlay" class="overlay-spinner">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- 集積所検索機能 -->
    <StationSearchContainer
        :map-instance="mapInstance"
        :stations-data="stationsData"
        :loading="l_map_overlay"
        @focus-on-location="handleFocusOnLocation"
        @station-selected="handleStationSelected"
        @search-performed="handleSearchPerformed"
      />
      <div id='stationmap'>
        <div id="left" class="sidebar flex-center left collapsed">
          <div id="sidebar-content" class="sidebar-content rounded-rect">
            <div class="m-3">
              <h5>清掃車両</h5>
              <BFormGroup>
                <BFormRadioGroup id="vehicle_btn-radios" v-model="l_vehicle_selected" buttons class="w-100"
                  @update:model-value="handlerVehicleStatus" stacked>
                  <BFormRadio v-for="option in l_vehicle_options" :key="option.text" :value="option.value"
                    :button-variant="option.buttonVariant">
                    {{ option.text }} ({{ option.num }})
                  </BFormRadio>
                </BFormRadioGroup>
              </BFormGroup>

              <div class="pt-2 border-top border-light">
                <h5>ステーション</h5>
              </div>

              <BInputGroup class="mt-1 w-100">
                <template #prepend>
                  <BInputGroupText>企業</BInputGroupText>
                </template>
                <BFormSelect id="company-type" v-model="l_company_selected" :options="l_company_options"
                  @update:model-value="handlerCompanyStatus"></BFormSelect>
              </BInputGroup>

              <BFormGroup>
                <BFormRadioGroup id="duration_btn-radios" v-model="l_duration_selected" buttons
                  @update:model-value="handlerStationDuration" class="w-100" stacked>
                  <BFormRadio v-for="option in l_duration_options" :key="option.text" :value="option.value">
                    {{ option.text }} ({{ option.num }})
                  </BFormRadio>
                </BFormRadioGroup>
              </BFormGroup>

              <div class="d-flex w-100 justify-content-between">
                <h6>家庭ごみ</h6>
                <BFormCheckbox switch v-model="l_householdGarbageValid" class="ml-2"
                  @update:model-value="handlerStationStatus">
                </BFormCheckbox>
              </div>

              <BFormGroup>
                <BFormRadioGroup id="vehicle_btn-radios" v-model="l_household_selected" buttons class="w-100"
                  @update:model-value="handlerStationStatus" stacked :disabled="!l_householdGarbageValid">
                  <BFormRadio v-for="option in l_household_options" :key="option.text" :value="option.value"
                    :button-variant="option.buttonVariant">
                    {{ option.text }} ({{ option.num }})
                  </BFormRadio>
                </BFormRadioGroup>
              </BFormGroup>

              <!-- 不法投棄の部分 -->
              <div class="d-flex w-100 justify-content-between">
                <h6>不法投棄</h6>
                <BFormCheckbox switch v-model="showIllegalDumpingMarkers" class="ml-2"
                  @update:model-value="toggleIllegalDumpingMarkers"></BFormCheckbox>
              </div>

              <BFormGroup>
                <BFormRadioGroup id="illegal_dumping_btn-radios" v-model="illegalSelected" buttons stacked class="w-100"
                  @update:model-value="handlerIllegalDumpingStatus" :disabled="!showIllegalDumpingMarkers">
                  <BFormRadio value="all" button-variant="outline-dark">
                    すべて({{ totalMarkers }})
                  </BFormRadio>
                  <BFormRadio value="uncollected" button-variant="outline-danger">
                    未回収 ({{ uncollectedMarkersCount }})
                  </BFormRadio>
                </BFormRadioGroup>
              </BFormGroup>

              <!-- ボタンとモーダル -->
              <div>
                <BButton class="w-100 aligh-middle" variant="primary" @click="showWindow"
                  :disabled="isCollectionProgressVisible">収集状況
                </BButton>
                <collection-progress-modal :apiData="progressData" :isUpdating="isUpdating"
                  ref="collectionProgressModal" @update-data="fetchUpdatedData"
                  @close-window="closeWindow"></collection-progress-modal>
              </div>

              <!-- 以下、凡例などの部分は同様に修正 -->
              <div>
                <h6 class="spacer">地図上の凡例</h6>
                <table class="spacer table table-bordered table-sm body-group ">
                  <tbody class="group-household">
                    <tr>
                      <th>事業者</th>
                      <th>集積所</th>
                      <th>車両</th>
                    </tr>
                    <tr>
                      <td class="company-name">あすま商事</td>
                      <td><img :src="icons['trash_household_green']" alt="ステーションアイコン" width="28" height="28"></td>
                      <td><img :src="icons['car_household_green']" alt="車両アイコン" width="28" height="28"></td>
                    </tr>
                    <tr>
                      <td class="company-name">桐の樹環境</td>
                      <td><img :src="icons['trash_household_blue']" alt="ステーションアイコン" width="28" height="28"></td>
                      <td><img :src="icons['car_household_blue']" alt="車両アイコン" width="28" height="28"></td>
                    </tr>
                    <tr>
                      <td class="company-name">春日部清掃</td>
                      <td><img :src="icons['trash_household_red']" alt="ステーションアイコン" width="28" height="28"></td>
                      <td><img :src="icons['car_household_red']" alt="車両アイコン" width="28" height="28"></td>
                    </tr>
                    <tr>
                      <td class="company-name">共栄衛生</td>
                      <td><img :src="icons['trash_household_yellow']" alt="ステーションアイコン" width="28" height="28"></td>
                      <td><img :src="icons['car_household_yellow']" alt="車両アイコン" width="28" height="28"></td>
                    </tr>
                  </tbody>
                  <tbody class="spacer">
                    <tr>
                      <td colspan="4"></td>
                    </tr>
                  </tbody>
                  <tbody class="group-other">
                    <tr>
                      <th>事業者</th>
                      <th>車両</th>
                    </tr>
                    <tr>
                      <td class="company-name">その他</td>
                      <td><img :src="icons['car_other']" alt="車両アイコン" width="28" height="28"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

    <IllegalInfoModal v-model:show="isModalVisible" :wasteData="selectedWasteData"
      @reset-data="resetSelectedWasteData" />
  </div>
</template>

<script>
import axios from 'axios'
import moment from "moment"
import { nextTick } from 'vue'
// MapLibre GL JSを読み込み
import maplibregl from 'maplibre-gl'
// Amplify読み込み
import { Auth, Signer } from 'aws-amplify'
//import awsconfig from '../aws-exports'
import geojson_household from './../../assets/geodata/station/household.json'
import geojson_recycle from './../../assets/geodata/station/recycle.json'

import illegal_collected from './../../assets/icons/不法投棄_収集済.png'
import illegal_uncollected from './../../assets/icons/不法投棄_未収集.png'
import IllegalInfoModal from './IllegalInfoModal.vue'
import CollectionProgressModal from './CollectionProgressModal.vue'
import StationSearchContainer from './../../pages/StationSearch/containers/StationSearchContainer.vue'

export default {
  name: 'MapModule',
  //春日部2nd実証実験対応:不法投棄情報
  components: {
    IllegalInfoModal,
    CollectionProgressModal,
    StationSearchContainer
  },
  data() {
    return {
      // 地図インスタンス（検索機能で使用）
      mapInstance: null,
      //春日部2nd実証実験対応:不法投棄情報
      isClustered: false,
      isCollectionProgressVisible: false,
      isModalVisible: false,
      selectedWasteData: {},
      showIllegalDumpingMarkers: true, // アイコンの表示状態を管理
      illegalDumpingMarkers: [],
      totalMarkers: 0, // アイコンの総数
      uncollectedMarkersCount: 0,
      illegalSelected: 'uncollected',
      illegalDumpingMarkers: [], // マーカーの配列
      clusteredMarkers: [], // 統合されたマーカーの配列
      dataFetchInterval: null, //データ取得のインターバルを保存するプロパティ
      illegalWasteData: [], // 不法投棄データを格納する配列
      //春日部2nd実証実験対応:収集状況
      progressData: {
        combustibleData: [],
        nonCombustibleData: [],
        overallCollectionRate: 0
      },
      isUpdating: false,
      // NEW-90
      // 不法投棄 トリガーcheckbox
      l_illegalValid: false,
      // 不法投棄 対象期間
      l_illegal_start_date: "2023-04-01",
      l_illegal_start_dateselected: "",
      l_illegal_end_dateselected: "",
      l_illegal_start_dateapplied: "",
      l_illegal_end_dateapplied: "",
      l_illegal_calendarApply_disabled: true,
      // 不法投棄データ格納
      l_illegalDumpingData: [],
      l_illegalDumpingDataFilter: [],

      // 不法投棄 ST格納DF
      l_illegalStationData: {},   // {stationId: {date: [], freq: N, illegalCombustible: N, illegalNonburnable: N, illegalHouseholdAppliances: N, illegalOtherGarbage: N}}
      l_illegalStationIds: [],

      // 不法投棄 頻度フィルター
      l_illegalFreq_selected: [0, 1, 2, 3, 4],
      // 不法投棄 頻度格納DF
      l_illegalFreq_options: [
        { text: 'すべて', value: 0, freq: 0, range: [0, 10000] },
        { text: '1日', value: 1, freq: 0, range: [1, 2] },
        { text: '2-3日', value: 2, freq: 0, range: [2, 4] },
        { text: '4-9日', value: 3, freq: 0, range: [4, 10] },
        { text: '10日以上', value: 4, freq: 0, range: [10, 10000] },
      ],
      l_popupStation: null,
      l_popupStationId: "",
      l_visibleStationIds: [],

      credentials: null,
      l_mapobject: null,

      // Component lifecycle state
      isDestroyed: false,

      // GUI LocalVariables
      l_map_overlay: true,

      // View Condition Parameters
      l_vehicle_selected: 'All',
      l_vehicle_options: [
        { value: 'All', text: 'すべて', buttonVariant: 'outline-dark', num: 0 },
        { value: 'Active', text: '稼働中', buttonVariant: 'outline-info', num: 0 },
        { value: 'InActive', text: '停止中', buttonVariant: 'outline-primary', num: 0 },
      ],
      l_household_selected: 'All',
      l_household_options: [
        { value: 'All', text: 'すべて', buttonVariant: 'outline-dark', num: 0 },
        { value: 'Empty', text: '回収済', buttonVariant: 'outline-info', num: 0 },
        { value: 'Full', text: '未回収', buttonVariant: 'outline-danger', num: 0 },
      ],
      l_recycle_selected: 'All',
      l_recycle_options: [
        { value: 'All', text: 'すべて', buttonVariant: 'outline-dark', num: 0 },
        { value: 'Empty', text: '回収/設置済', buttonVariant: 'outline-secondary', num: 0 },
        { value: 'Full', text: '未回収', buttonVariant: 'outline-primary', num: 0 },
        { value: 'NoReady', text: '未設置', buttonVariant: 'outline-warning', num: 0 },
      ],
      l_duration_selected: 'All',
      l_duration_options: [
        { value: 'All', text: 'すべて', num: 0 },
        { value: 'TodayTarget', text: '本日対象分', num: 0 },
        // { value: 'Today', text: '本日更新分', num:0},
      ],
      l_date_selected: '',
      l_todaytarget_selected: false,

      //収集地区情報
      l_collectionArea_selected: 0,
      l_collectionArea_options: [],

      //企業情報
      l_company_selected: '',
      l_company_options: [],
      l_map_selected: 'Honeycomb_Here_Explore',
      l_map_options: [
        { value: 'Honeycomb_Here_Explore', text: '地図', icon: "map" },
        { value: 'Honeycomb_Esri_Satellite', text: '航空写真', icon: "globe" },
        { value: 'OpenStreetMap', text: 'OpenStreetMap（開発用）', icon: "map" },
      ],

      l_householdGarbageValid: true,
      l_recycleGarbageValid: true,

      // Geo Layer Ids
      l_layer_vehicle_active_id: 'vehicle-active',
      l_layer_vehicle_inactive_id: 'vehicle-inactive',
      l_layer_station_id: 'stations',
      l_layer_station_empty_household_apdx: 'empty-household',
      l_layer_station_full_household_apdx: 'full-household',
      l_layer_station_empty_recycle_apdx: 'empty-recycle',
      l_layer_station_full_recycle_apdx: 'full-recycle',
      l_layer_station_noready_recycle_apdx: 'noready-recycle',

      l_currentZoomLevel: 11,
      l_currentLonLat: [],

      // Station Icon
      l_household_icon: null,
      l_recycle_icon: null,

      l_stationListGeoJSON: {
        type: "FeatureCollection",
        features: [
        ]
      },
      l_vehicleListGeoJSON: {
        type: "FeatureCollection",
        features: [
        ]
      },
      icons: {},
      uniqueCompanyIds: ["0", "1", "2", "3", "4", "5", , "6", "7", "8", ""],
      // アイコン画像の対応関係を定義するマッピングテーブル
      trashMapping: {
        "0": {
          Empty: "trash_empty",
          Full: "trash_household_blue"
        },
        "1": {
          Empty: "trash_empty",
          Full: "trash_companyId_nan"
        },
        "2": {
          Empty: "trash_empty",
          Full: "trash_household_green"
        },
        "3": {
          Empty: "trash_empty",
          Full: "trash_household_red"
        },
        "4": {
          Empty: "trash_empty",
          Full: "trash_household_yellow"
        },
        "5": {
          Empty: "trash_empty",
          Full: "trash_companyId_nan"
        },
        "6": {
          Empty: "trash_empty",
          Full: "trash_companyId_nan"
        },
        "7": {
          Empty: "trash_empty",
          Full: "trash_companyId_nan"
        },
        "8": {
          Empty: "trash_empty",
          Full: "trash_companyId_nan"
        },
        "": {
          Empty: "trash_empty",
          Full: "trash_companyId_nan"
        },
      },
      carMapping: {
        "0": {
          'vehicle-active': 'car_household_blue',
          'vehicle-inactive': 'car_household_stop'
        },
        "1": {
          'vehicle-active': 'car_other',
          'vehicle-inactive': 'car_other'
        },
        "2": {
          'vehicle-active': 'car_household_green',
          'vehicle-inactive': 'car_household_stop'
        },
        "3": {
          'vehicle-active': 'car_household_red',
          'vehicle-inactive': 'car_household_stop'
        },
        "4": {
          'vehicle-active': 'car_household_yellow',
          'vehicle-inactive': 'car_household_stop'
        },
        "5": {
          'vehicle-active': 'car_other',
          'vehicle-inactive': 'car_other_stop'
        },
        "6": {
          'vehicle-active': 'car_other',
          'vehicle-inactive': 'car_other_stop'
        },
        "7": {
          'vehicle-active': 'car_other',
          'vehicle-inactive': 'car_other_stop'
        },
        "8": {
          'vehicle-active': 'car_other',
          'vehicle-inactive': 'car_other_stop'
        },
        "": {
          'vehicle-active': 'car_other',
          'vehicle-inactive': 'car_other_stop_stop'
        },
      },
      companyNameToId: {
        "三協清掃株式会社": "0",
        "あすま商事": "2",
        "春日部清掃": "3",
        "共栄衛生": "4",
        "パナソニックITS株式会社": "8",
        "": "",
      },
    }
  },
  created() {
    // 静的インポートで個別にアイコンを読み込み
    this.icons = {
      'trash_household_blue': new URL('./../../assets/icons/addIcons/trash_household_blue.png', import.meta.url).href,
      'trash_household_green': new URL('./../../assets/icons/addIcons/trash_household_green.png', import.meta.url).href,
      'trash_household_red': new URL('./../../assets/icons/addIcons/trash_household_red.png', import.meta.url).href,
      'trash_household_yellow': new URL('./../../assets/icons/addIcons/trash_household_yellow.png', import.meta.url).href,
      'car_household_blue': new URL('./../../assets/icons/addIcons/car_household_blue.png', import.meta.url).href,
      'car_household_green': new URL('./../../assets/icons/addIcons/car_household_green.png', import.meta.url).href,
      'car_household_red': new URL('./../../assets/icons/addIcons/car_household_red.png', import.meta.url).href,
      'car_household_yellow': new URL('./../../assets/icons/addIcons/car_household_yellow.png', import.meta.url).href,
      'car_household_stop': new URL('./../../assets/icons/addIcons/car_household_stop.png', import.meta.url).href,
      'car_other': new URL('./../../assets/icons/addIcons/car_other.png', import.meta.url).href,
      'car_other_stop': new URL('./../../assets/icons/addIcons/car_other_stop.png', import.meta.url).href,
      'trash_empty': new URL('./../../assets/icons/addIcons/trash_empty.png', import.meta.url).href,
      'trash_companyId_nan': new URL('./../../assets/icons/addIcons/trash_companyId_nan.png', import.meta.url).href
    };
    console.log('Static import icons:', this.icons);
  },
  beforeUnmount() {
    console.log('MapModule component is being destroyed');
    this.isDestroyed = true;
    this.stopDataFetchInterval();
  },
  computed: {
    // stationsDataをリアクティブなcomputedプロパティとして定義
    stationsData() {
      return this.$store.getters.stationData ? this.$store.getters.stationData.stStatus : [];
    }
  },
  async mounted() {
    console.log('StationMapModule mounted start');

    // コンポーネントの初期化が完了するのを待つ
    await nextTick();

    // DOM要素の存在確認
    const mapContainer = document.getElementById('stationmap');
    if (!mapContainer) {
      console.error('stationmap container not found during mount');
      return;
    }

    // dataオプションの初期値が設定されていることを確認
    console.log('Initial l_map_selected:', this.l_map_selected);

    this.$store.watch(
      (state, getters) => getters.todayStationDataRefreshTime,
      async (newValue, oldValue) => {
        if (oldValue == null) {
          await this.initData()
        } else {
          await this.refreshData()
        }
      }
    )

    if (this.$store.getters.todayStationDataRefreshTime != null) {
      await this.initData()
    }

    // 1分ごとにデータを取得する
    this.dataFetchInterval = setInterval(() => {
      this.fetchIllegalWasteData();
    }, 60000); // 60000ミリ秒 = 1分
    // this.l_mapobject.on('zoom', this.updateMarkerVisibility);
    // this.fetchIllegalWasteData();
  },
  methods: {
    // 検索機能のハンドラーメソッド（Vue 3対応）
    handleFocusOnLocation(location) {
      if (this.mapInstance && location.lat && location.lng) {
        this.mapInstance.flyTo({
          center: [location.lng, location.lat],
          zoom: 16,
          duration: 1000
        });
      }
    },

    async handleStationSelected(station) {
      if (this.mapInstance && station.lat && station.lng) {
        this.mapInstance.flyTo({
          center: [station.lng, station.lat],
          zoom: 16,
          duration: 1000
        });

        // DOM更新を待つ
        await nextTick();

        // 選択されたステーションにフォーカス
        console.log('Station selected:', station);
      }
    },

    handleSearchPerformed(searchData) {
      console.log('Search performed:', searchData);
      // 必要に応じて検索結果の処理を追加
    },

    // 不法投棄情報のハンドラーメソッド（Vue 3対応）
    toggleIllegalDumpingMarkers() {
      if (this.showIllegalDumpingMarkers) {
        this.addIllegalDumpingMarkers();
      } else {
        this.removeIllegalDumpingMarkers();
      }
    },

    handlerIllegalDumpingStatus() {
      if (this.illegalSelected === 'all') {
        // すべてのマーカーを表示
        this.showAllIllegalMarkers();
      } else if (this.illegalSelected === 'uncollected') {
        // 未回収のマーカーのみ表示
        this.showUncollectedIllegalMarkers();
      }
    },

    addIllegalDumpingMarkers() {
      // 不法投棄マーカーを地図に追加する実装
      console.log('Adding illegal dumping markers');
    },

    removeIllegalDumpingMarkers() {
      // 不法投棄マーカーを地図から削除する実装
      console.log('Removing illegal dumping markers');
    },

    showAllIllegalMarkers() {
      console.log('Showing all illegal markers');
    },

    showUncollectedIllegalMarkers() {
      console.log('Showing uncollected illegal markers');
    },

    // 収集状況モーダル関連のメソッド（Vue 3対応）
    showWindow() {
      this.isCollectionProgressVisible = true;
      this.$refs.collectionProgressModal.show();
    },

    closeWindow() {
      this.isCollectionProgressVisible = false;
    },

    async fetchUpdatedData() {
      this.isUpdating = true;
      try {
        // データ更新の実装
        await new Promise(resolve => setTimeout(resolve, 1000)); // 仮の遅延
        console.log('Data updated');
      } catch (error) {
        console.error('Failed to update data:', error);
      } finally {
        this.isUpdating = false;
      }
    },

    resetSelectedWasteData() {
      this.selectedWasteData = {};
      this.isModalVisible = false;
    },

    stopDataFetchInterval() {
      if (this.dataFetchInterval) {
        clearInterval(this.dataFetchInterval);
        this.dataFetchInterval = null;
      }
    },

    async fetchIllegalWasteData() {
      // 不法投棄データの取得実装
      try {
        console.log('Fetching illegal waste data...');
        // 実際のAPI呼び出しをここに実装
      } catch (error) {
        console.error('Failed to fetch illegal waste data:', error);
      }
    },

    // Common Function ============================
    initData: async function () {
      // コンポーネントが破棄されている場合は処理を中断
      if (this.isDestroyed) {
        console.log('Component is destroyed, skipping initData');
        return;
      }

      try {
        // 認証情報の取得を最初に行う
        this.credentials = await Auth.currentCredentials();
        console.log('New credentials fetched:', this.credentials);
      } catch (error) {
        console.error('Failed to fetch credentials:', error);
      }

      //企業情報の初期化
      this.l_company_selected = ''
      this.l_company_options = this.getCompanyOptions();

      //収集情報の初期化
      this.l_collectionArea_selected = 0
      this.l_collectionArea_options = this.getCollectionOptions();

      // ストアデータの準備を待つ
      let retryCount = 0;
      const maxRetries = 10;
      while (retryCount < maxRetries) {
        const stationData = this.$store.getters.stationData;
        const vehicleData = this.$store.getters.vehicleData;

        if (stationData && stationData.stStatus && vehicleData && vehicleData.vehicleStatus) {
          console.log('Store data is ready, proceeding with data update');
          break;
        }

        console.log(`Waiting for store data... attempt ${retryCount + 1}/${maxRetries}`);
        await new Promise(resolve => setTimeout(resolve, 500)); // 500ms待機
        retryCount++;
      }

      // データ取得を同期的に待つ
      await this.getVehicleDataWrapper()
      await this.getStationDataWrapper()
      // Mapping Todays Target
      await this.getTodayStationDataWrapper();

      // Call Refresh Credentials
      await this.refreshCredentials();
      // Create Map Object
      const mapResult = await this.mapCreate(this.l_map_selected);

      if (!mapResult) {
        console.warn('Map creation failed, skipping UpdateStationCount');
        return;
      }

      // カウント更新はgetStationDataWrapper内で実行される
    },
    refreshData: async function () {
      // コンポーネントが破棄されている場合は処理を中断
      if (this.isDestroyed) {
        console.log('Component is destroyed, skipping refreshData');
        return;
      }

      await this.getVehicleDataWrapper()
      await this.getStationDataWrapper()
      await this.getTodayStationDataWrapper();

      if (this.l_todaytarget_selected == false) {
        this.UpdateStationCount("All")
      } else {
        this.UpdateStationCount("TodayTarget")
      }
      this.handlerStationDuration()
      this.handlerVehicleStatus()
    },
    viewStationStatus() {
      if (this.l_householdGarbageValid == true) {
        if (this.l_recycleGarbageValid == true) {
          this.clearStationLayers();
          this.showStationLayers(this.l_household_selected, this.l_recycle_selected);
        } else {
          this.clearStationLayers();
          this.showStationLayers(this.l_household_selected, null);
        }
      } else {
        if (this.l_recycleGarbageValid == true) {
          this.clearStationLayers();
          this.showStationLayers(null, this.l_recycle_selected);
        } else {
          this.clearStationLayers();
          this.showStationLayers(null, null);
        }
      }
    },
    handlerColletionAreaStatus(event) {
      //収集地区情報更新に伴うステーションの更新
      this.getStationDataWrapper()
      this.getTodayStationDataWrapper()
      if (this.l_todaytarget_selected == false) {
        this.UpdateStationCount("All")
      } else {
        this.UpdateStationCount("TodayTarget")
      }
      this.viewStationStatus()
    },
    handlerCompanyStatus(event) {
      //企業情報更新に伴うステーションの更新
      this.getStationDataWrapper()
      this.getTodayStationDataWrapper()
      if (this.l_todaytarget_selected == false) {
        this.UpdateStationCount("All")
      } else {
        this.UpdateStationCount("TodayTarget")
      }
      this.viewStationStatus()
    },
    // GUI Handler ================================
    // Handler of Changing Station Status
    handlerStationStatus(event) {
      this.viewStationStatus()
    },
    // Handler of Changing Vehicle Status
    handlerVehicleStatus(event) {
      console.log("handlerVehicleStatus")
      // Status Active : Add Active Vehicle Layer
      if (this.l_vehicle_selected == "Active") {
        // Hide InActive Vehicle Layers, Show Active Layers
        this.clearInActiveVehicleLayers();
        this.showActiveVehicleLayers();
      }
      // Status InActive : Add InActive Vehicle Layer
      else if (this.l_vehicle_selected == "InActive") {
        // Hide Active Vehicle Layers, Show InActive Layers
        this.clearActiveVehicleLayers();
        this.showInActiveVehicleLayers();
      }
      // Status ALL or Other : Add All Vehicle Layer
      else {
        this.clearActiveVehicleLayers();
        this.showActiveVehicleLayers();
        this.clearInActiveVehicleLayers();
        this.showInActiveVehicleLayers();
      }
    },

    // Handler of Changing Station Duration
    handlerStationDuration: async function (event) {
      if (this.l_duration_selected == "Today") {
        this.l_date_selected = moment().format('YYYY/MM/DD');
      }
      else if (this.l_duration_selected == "TodayTarget") {
        this.l_todaytarget_selected = true
        this.UpdateStationCount("TodayTarget")
      }
      else {
        this.l_date_selected = ""
        this.l_todaytarget_selected = false
        this.UpdateStationCount("All")
      }

      this.handlerStationStatus();
      // this.clearStationLayers();
      // this.showStationLayers(this.l_household_selected, this.l_recycle_selected);
    },

    // NEW-90
    initEditIllegalDate() {
      if (this.l_illegal_end_dateselected < this.l_illegal_start_dateselected) {
        this.l_illegal_end_dateselected = this.l_illegal_start_dateselected
      }

      if (this.l_illegal_start_dateselected == this.l_illegal_start_dateapplied &&
        this.l_illegal_end_dateselected == this.l_illegal_end_dateapplied) {
        this.l_illegal_calendarApply_disabled = true;
      } else {
        this.l_illegal_calendarApply_disabled = false;
      }
    },
    dateDisabledIllegal(ymd, date) {
      var startDate = new Date(this.l_illegal_start_dateselected)
      startDate.setDate(startDate.getDate() - 1)
      return date <= startDate
    },
    filter_byIllegalPeriod() {
      const st = this.l_illegal_start_dateselected.replaceAll('-', '/')
      const ed = this.l_illegal_end_dateselected.replaceAll('-', '/')
      var illegalDumpingDataFilter = JSON.parse(JSON.stringify(this.l_illegalDumpingData))
      illegalDumpingDataFilter = illegalDumpingDataFilter.filter((item, index) => {
        // illegalDumping.dateによるフィルター操作
        const illegalDumping = item.illegalDumping.filter(e => { return (ed >= e.illegalDumpingDate && e.illegalDumpingDate >= st) });
        illegalDumpingDataFilter[index]['illegalDumping'] = illegalDumping;
        // illegalDumping = []の場合: stationIdの情報ごと削除
        return illegalDumping.length > 0
      })
      this.l_illegal_start_dateapplied = this.l_illegal_start_dateselected;
      this.l_illegal_end_dateapplied = this.l_illegal_end_dateselected;
      this.l_illegal_calendarApply_disabled = true;
      return illegalDumpingDataFilter
    },
    countIllegal_perStation() {
      // 各STの不法投棄頻度算出　popup表示で使用
      var obj = {};
      this.l_illegalDumpingDataFilter.forEach(item => {
        const freq = item.illegalDumping.length
        let date = [];
        let illegalCombustible = 0;
        let illegalNonburnable = 0;
        let illegalHouseholdAppliances = 0;
        let illegalOtherGarbage = 0;
        item.illegalDumping.forEach(e => {
          date.push(e.illegalDumpingDate);
          illegalCombustible += parseInt(e.illegalCombustible);
          illegalNonburnable += parseInt(e.illegalNonburnable);
          illegalHouseholdAppliances += parseInt(e.illegalHouseholdAppliances);
          illegalOtherGarbage += parseInt(e.illegalOtherGarbage);
        })
        obj[item.stationId] = {
          freq: freq,
          date: date,
          illegalCombustible: illegalCombustible,
          illegalNonburnable: illegalNonburnable,
          illegalHouseholdAppliances: illegalHouseholdAppliances,
          illegalOtherGarbage: illegalOtherGarbage,
        }
      })
      this.l_illegalStationData = obj;
      this.l_illegalStationIds = Object.keys(obj)
    },
    countIllegal_perFreqency(freq) {
      // 頻度カテゴリ毎のST数計算
      this.l_illegalFreq_options[0]['freq'] += 1;
      for (let i = 1; i < this.l_illegalFreq_options.length; i++) {
        // min: 最小頻度, max: 最大頻度
        let min = this.l_illegalFreq_options[i]['range'][0];
        let max = this.l_illegalFreq_options[i]['range'][1];
        if (max > freq && freq >= min) {
          this.l_illegalFreq_options[i]['freq'] += 1;
          break;
        }
      }
    },
    async handlerIllgalDumpingTriger(event) {
      this.l_illegal_start_dateselected = this.l_illegal_start_date;
      this.l_illegal_end_dateselected = moment().local().format('YYYY-MM-DD');

      var sideBar = document.getElementById('left')
      var sideBar_content = document.getElementById('sidebar-content')
      if (this.l_illegalValid) {
        sideBar.style.width = "320px"
        sideBar_content.scrollTop = 460;  //360
        this.l_illegalFreq_selected = [0, 1, 2, 3, 4]
        await this.getIllegalDumpingInformationRequestWrapper();
      } else {
        sideBar.style.width = "280px"
        sideBar_content.scrollTop = 0;
        // getIllegalDumpingInformationRequestWrapper()に相当
        this.l_illegalDumpingDataFilter = [];
      }
      // popup情報の削除
      if (this.l_popupStation != null) {
        this.l_popupStation.remove();
        this.l_popupStation = null;
        this.l_popupStationId = "";
      }

      // Dashboard の通常表示
      this.getStationDataWrapper()
      this.getTodayStationDataWrapper()
      if (this.l_todaytarget_selected == false) {
        this.UpdateStationCount("All")
      } else {
        this.UpdateStationCount("TodayTarget")
      }
      this.viewStationStatus()
    },
    handlerIllegalDumpingCalendar() {
      this.l_illegalDumpingDataFilter = this.filter_byIllegalPeriod();
      this.countIllegal_perStation();

      this.getStationDataWrapper()
      this.getTodayStationDataWrapper()
      if (this.l_todaytarget_selected == false) {
        this.UpdateStationCount("All")
      } else {
        this.UpdateStationCount("TodayTarget")
      }
      this.viewStationStatus()
    },
    handlerIllegalDumpingAll(event) {
      // スイッチ操作後 update
      if (this.l_illegalFreq_selected.includes(0)) {
        this.l_illegalFreq_selected = [0, 1, 2, 3, 4]
      } else {
        this.l_illegalFreq_selected = []
      }
      this.viewStationStatus()
    },
    handlerIllegalDumping(event) {
      // スイッチ操作後 update
      // [すべて]選択時に、他の選択肢が解除された場合、[すべて]も解除
      if (this.l_illegalFreq_selected.includes(0) && this.l_illegalFreq_selected.length != 5) {
        this.l_illegalFreq_selected = this.l_illegalFreq_selected.filter(e => e != 0)
      }
      // [すべて]未選択時に、他の選択肢がすべて選択された場合、[すべて]も選択
      if (!this.l_illegalFreq_selected.includes(0) && this.l_illegalFreq_selected.length == 4) {
        this.l_illegalFreq_selected.push(0)
      }
      this.viewStationStatus()
    },

    // Handler of Changing Map
    handlerMapStyle(event) {
      // Create Map Object
      this.mapCreate(this.l_map_selected);
    },

    // Update Vehicle Locations
    updateVehicleLocation(data) {
      var allVehicle = 0;
      var activeVehicle = 0;
      var inactiveVehicle = 0;

      var features = [];
      for (var i in data) {
        var vehicleStatus = (data[i].CollectOperationStatus == 0) ? 'Active' : 'InActive'
        var companyName = data[i].companyName
        var companyId = this.companyNameToId[data[i].companyName]
        var vehicleId = data[i].vehicleId
        var routeId = data[i].routeId
        var latlon = [data[i].longitude, data[i].latitude]
        var lastupdatets = data[i]['last-update'].replaceAll("/", "-")
        var lastUpdate = moment.utc(lastupdatets).local().format('YYYY/MM/DD HH:mm:ss')

        var part = {
          type: "Feature",
          properties: {
            id: vehicleId,
            companyId: companyId,
            company: companyName,
            route: routeId,
            status: vehicleStatus,
            timestamp: lastUpdate
          },
          geometry: {
            type: "Point",
            coordinates: latlon
          }
        }
        features.push(part)

        if (vehicleStatus == 'Active') {
          activeVehicle = activeVehicle + 1;
        } else {
          inactiveVehicle = inactiveVehicle + 1;
        }
        allVehicle = allVehicle + 1;
      }

      this.l_vehicleListGeoJSON = {
        type: "FeatureCollection",
        features: features
      }

      this.l_vehicle_options[0].num = allVehicle // All
      this.l_vehicle_options[1].num = activeVehicle // Active
      this.l_vehicle_options[2].num = inactiveVehicle // Inactive
    },
    // Update Staion Location
    updateStationLocation(data) {
      var allStations = 0;
      var features = [];
      for (var i in data) {
        var stationName = data[i].stName
        var stationId = data[i].controlNumber
        var stationType = ""
        var status = ""
        var garbageType = String(data[i].garbageType)
        var collectionStatus = String(data[i].collectStatus)
        var companyId = ""

        if (data[i].company.length > 0) {
          companyId = data[i].company[0].companyId;
        }

        if (this.l_company_selected == '' || companyId.indexOf(this.l_company_selected) >= 0) {
          // House - Full
          if (garbageType == '0' && collectionStatus == '0') {
            stationType = "HouseholdGarbage"
            status = "Full"
          }
          // House - Empty
          else if (garbageType == '0' && collectionStatus == '1') {
            stationType = "HouseholdGarbage"
            status = "Empty"
          }
          else {
            continue;
          }

          var latlon = [Number(data[i].longitude), Number(data[i].latitude)]
          var lastupdatets = data[i]['last-update'].replaceAll("/", "-")
          var lastupdatets2 = data[i]['last-update2'].replaceAll("/", "-")
          var lastupdatets3 = data[i]['last-update3'].replaceAll("/", "-")
          var lastUpdate = (lastupdatets == "") ? "" : moment.utc(lastupdatets).local().format('YYYY/MM/DD HH:mm:ss')
          var lastUpdate2 = (lastupdatets2 == "") ? "" : moment.utc(lastupdatets2).local().format('YYYY/MM/DD HH:mm:ss')
          var lastUpdate3 = (lastupdatets3 == "") ? "" : moment.utc(lastupdatets3).local().format('YYYY/MM/DD HH:mm:ss')

          var date = lastUpdate.split(' ')[0]

          // NEW-90 popup 表示内容追加
          var idx = this.l_illegalStationIds.indexOf(stationId)
          var freq = 0;
          var illegalCombustible = 0;
          var illegalNonburnable = 0;
          var illegalHouseholdAppliances = 0;
          var illegalOtherGarbage = 0;
          if (idx != -1) {
            freq = this.l_illegalStationData[stationId]['freq']
            illegalCombustible = this.l_illegalStationData[stationId]['illegalCombustible']
            illegalNonburnable = this.l_illegalStationData[stationId]['illegalNonburnable']
            illegalHouseholdAppliances = this.l_illegalStationData[stationId]['illegalHouseholdAppliances']
            illegalOtherGarbage = this.l_illegalStationData[stationId]['illegalOtherGarbage']
          }

          var part = {
            type: "Feature",
            properties: {
              name: stationName,
              id: stationId,
              type: stationType,
              status: status,
              timestamp: lastUpdate,
              timestamp2: lastUpdate2,
              timestamp3: lastUpdate3,
              datetimestamp: date,
              today: false,
              companyId: companyId,
              freq: freq,
              illegalCombustible: illegalCombustible,
              illegalNonburnable: illegalNonburnable,
              illegalHouseholdAppliances: illegalHouseholdAppliances,
              illegalOtherGarbage: illegalOtherGarbage,
            },
            geometry: {
              type: "Point",
              coordinates: latlon
            }
          }
          features.push(part)
          allStations = allStations + 1
        }
      }

      this.l_stationListGeoJSON = {
        type: "FeatureCollection",
        features: features
      }

      // All Stations Counter
      this.l_duration_options[0].num = allStations
    },
    // Update Staion Today
    updateStationLocationToday(list, len) {
      len = 0
      for (var i in this.l_stationListGeoJSON.features) {
        var todayData = list[this.l_stationListGeoJSON.features[i].properties.id]
        if (todayData === undefined) {
          todayData = { 'todayFlg': false }
        }
        if (todayData.todayFlg == true) {
          var companyId_target = []
          var company = todayData.company
          for (var j in company) {
            companyId_target.push(company[j].companyId)
          }
          if (this.l_company_selected == '' || companyId_target.indexOf(this.l_company_selected) >= 0) {
            this.l_stationListGeoJSON.features[i].properties.today = true
            len = len + 1
          }
        } else {
          this.l_stationListGeoJSON.features[i].properties.today = false
        }
      }

      // All Stations Counter
      this.l_duration_options[1].num = len
    },
    // Update Station Count
    UpdateStationCount(type) {
      var allHouseholdCount = 0;
      var emptyHouseholdCount = 0;
      var fullHouseholdCount = 0;

      // 頻度数カテゴリ毎テーブルの初期化
      if (this.l_illegalValid) this.l_illegalFreq_options.forEach(e => e.freq = 0)
      var data = this.l_stationListGeoJSON.features
      if (type == "All") {
        for (var i in data) {
          var stationType = data[i].properties.type
          var status = data[i].properties.status
          if (stationType == 'HouseholdGarbage') {
            if (status == "Full") {
              fullHouseholdCount = fullHouseholdCount + 1
            } else {
              emptyHouseholdCount = emptyHouseholdCount + 1
            }
            allHouseholdCount = allHouseholdCount + 1;
          }
          // NEW-90 頻度数カテゴリ毎のST数算出
          // modeが不法投棄表示       頻度>0
          if (this.l_illegalValid && data[i].properties.freq > 0) this.countIllegal_perFreqency(data[i].properties.freq)
        }
      } else if (type == "TodayTarget") {
        for (var i in data) {
          var stationType = data[i].properties.type
          var status = data[i].properties.status
          var today = data[i].properties.today
          if (today == true) {
            if (stationType == 'HouseholdGarbage') {
              if (status == "Full") {
                fullHouseholdCount = fullHouseholdCount + 1
              } else {
                emptyHouseholdCount = emptyHouseholdCount + 1
              }
              allHouseholdCount = allHouseholdCount + 1;
            }
            if (this.l_illegalValid && data[i].properties.freq > 0) this.countIllegal_perFreqency(data[i].properties.freq)
          }
        }
      }

      this.l_household_options[0].num = allHouseholdCount // All
      this.l_household_options[1].num = emptyHouseholdCount // Empty
      this.l_household_options[2].num = fullHouseholdCount // Full

    },
    // Update Credentials (Amplify v5.3.12対応)
    // Update Credentials (Amplify v5.3.12対応)
    refreshCredentials: async function () {
      try {
        this.credentials = await Auth.currentCredentials();
        console.log('Credentials refreshed:', this.credentials);

        // 次の認証更新をスケジュール
        setTimeout(this.refreshCredentials, this.credentials.expiration - new Date());
      } catch (error) {
        console.error('Error refreshing credentials:', error);
        // エラーが発生した場合は5分後に再試行
        setTimeout(this.refreshCredentials, 5 * 60 * 1000);
      }
    },
    // Clear Layer of Active Vehicles
    clearActiveVehicleLayers() {
      // Active
      this.removeDotLayers(this.l_layer_vehicle_active_id);
    },
    // Clear Layer of InActive Vehicles
    clearInActiveVehicleLayers() {
      // InActive
      this.removeDotLayers(this.l_layer_vehicle_inactive_id);
    },
    // Show Layer of Active Vehicles
    showActiveVehicleLayers() {
      if (!this.l_mapobject) return;
      var condition = 'Active';
      var centercolor = "#1E7C3C";
      var outercolor = "#91EAA1";
      var id = this.l_layer_vehicle_active_id;
      if (this.l_mapobject.getLayer(id)) { }
      else {
        var Vehicles = this.l_vehicleListGeoJSON.features.filter(function (item, index) {
          if (item.properties.status == condition) return true;
        });
        this.addDotLayers(id, centercolor, outercolor,
          {
            type: "FeatureCollection",
            features: Vehicles
          }
        );
      }
    },
    // Show Layer of InActive Vehicles
    showInActiveVehicleLayers() {
      if (!this.l_mapobject) return;
      var condition = 'InActive';
      var centercolor = "#FFB11B";
      var outercolor = "#FFFF94";
      var id = this.l_layer_vehicle_inactive_id;
      if (this.l_mapobject.getLayer(id)) { }
      else {
        var Vehicles = this.l_vehicleListGeoJSON.features.filter(function (item, index) {
          if (item.properties.status == condition) return true;
        });
        this.addDotLayers(id, centercolor, outercolor,
          {
            type: "FeatureCollection",
            features: Vehicles
          }
        );
      }
    },
    getFilterData(data) {
      // NEW-90 頻度フィルター設定に対する対応
      // 頻度チェックボタンがFalseの時は、全て通過
      var dataFilter = [];
      if (this.l_illegalFreq_selected.length == 0) {
        dataFilter = [];
      } else if (this.l_illegalFreq_selected.length == 5) {
        dataFilter = data.filter(e => this.l_illegalStationIds.includes(e.properties.id))
      } else {
        const illegalStationIdsFilter = this.l_illegalStationIds.filter(id => {
          const stationFreq = this.l_illegalStationData[id]['freq'];
          var ret = false
          for (let idx of this.l_illegalFreq_selected) {
            const minFreq = this.l_illegalFreq_options[idx]['range'][0]
            const maxFreq = this.l_illegalFreq_options[idx]['range'][1]

            if (maxFreq > stationFreq && stationFreq >= minFreq) {
              ret = true;
              break;
            }
          }
          return ret
        })

        dataFilter = data.filter(e => illegalStationIdsFilter.includes(e.properties.id))
      }
      return dataFilter;
    },
    // Show Layer of Stations
    showStationLayers(household, recycle) {
      var household_status_condition = household;
      var id = this.l_layer_station_id;

      var todaycount = 0;
      var nottodaycount = 0;
      if (this.l_mapobject.getLayer(id)) { console.log() }
      else {
        var datefilter = []
        var visibleStationIds = []
        var stationListGeoJsonFilter = (!this.l_illegalValid) ? this.l_stationListGeoJSON.features : this.getFilterData(this.l_stationListGeoJSON.features);

        var Stations = stationListGeoJsonFilter.filter(function (item, index) {
          var ret = false;

          if (this.l_company_selected == '' || item.properties.companyId.toString() == this.l_company_selected.toString()) {
            // Household
            if (item.properties.type == 'HouseholdGarbage') {
              if (household_status_condition == null) {
                ret = false;
              }
              else {
                if (household_status_condition == 'All') {
                  ret = true;
                }
                else {
                  if (item.properties.status == household_status_condition) {
                    ret = true;
                  }
                }
              }
            }

            // Date
            // if(this.l_date_selected != ""){
            // 	if(item.properties.datetimestamp == this.l_date_selected){
            // 		// Date selected and same as it then, set as visible
            // 		ret = true
            // 		datefilter = [["==", "datetimestamp", this.l_date_selected]]
            // 	}
            // 	else{
            // 		// Date selected and NOT same as it then, set as invisible
            // 		ret = false
            // 		datefilter = []
            // 	}
            // }else{
            // 	// Do not filter by date because not set date
            // }

            // Today
            // If the station should be shown at before step, need to check today filter
            if (ret == true) {
              if (this.l_todaytarget_selected != false) {
                if (item.properties.today == this.l_todaytarget_selected) {
                  todaycount++
                  // Date selected and same as it then, set as visible
                  ret = true
                  datefilter = [["==", "today", this.l_todaytarget_selected]]
                }
                else {
                  nottodaycount++
                  // Date selected and NOT same as it then, set as invisible
                  ret = false
                  datefilter = []
                }
              } else {
                // Do not filter by date because not set date
              }
            }
          } else {
            ret = false
          }
          if (ret) visibleStationIds.push(item.properties.id)
          return ret;
        }.bind(this));
        this.l_visibleStationIds = visibleStationIds
        if (this.l_popupStation != null) {
          // ステーションが非表示になった場合、ポップアップを削除
          if (!this.l_visibleStationIds.includes(this.l_popupStationId)) {
            this.l_popupStation.remove();
            this.l_popupStation = null;
            this.l_popupStationId = "";
          } else {
            // 不法投棄のポップアップは表示内容を更新する（カレンダー設定によって表示内容が異なる）
            if (this.l_illegalValid) {
              var station = Stations.filter(e => e.properties.id == this.l_popupStationId)[0].properties
              var comment =
                '管理番号 : ' + station.name + '<br>' +
                //		    		    		'最終更新 : ' + station.timestamp + '<br>' +
                '不法投棄 (' + station.freq + ' 日)<br>' +
                '　　可燃 (' + station.illegalCombustible + ' 回)<br>' +
                '　　不燃 (' + station.illegalNonburnable + ' 回)<br>' +
                '　　家電 (' + station.illegalHouseholdAppliances + ' 回)<br>' +
                '　その他 (' + station.illegalOtherGarbage + ' 回)'
              this.l_popupStation.setHTML(comment)
            }
          }
        }
        this.uniqueCompanyIds.forEach(companyId => {
          if (household_status_condition == 'Empty') {
            this.addUnClusterLayers(id, { type: "FeatureCollection", features: Stations }, this.l_layer_station_empty_household_apdx, [["==", "status", "Empty"], ["==", "type", "HouseholdGarbage"]].concat(datefilter), companyId);
          } else if (household_status_condition == 'Full') {
            this.addUnClusterLayers(id, { type: "FeatureCollection", features: Stations }, this.l_layer_station_full_household_apdx, [["==", "status", "Full"], ["==", "type", "HouseholdGarbage"]].concat(datefilter), companyId);
          } else {
            this.addUnClusterLayers(id, { type: "FeatureCollection", features: Stations }, this.l_layer_station_empty_household_apdx, [["==", "status", "Empty"], ["==", "type", "HouseholdGarbage"]].concat(datefilter), companyId);
            this.addUnClusterLayers(id, { type: "FeatureCollection", features: Stations }, this.l_layer_station_full_household_apdx, [["==", "status", "Full"], ["==", "type", "HouseholdGarbage"]].concat(datefilter), companyId);
          }
        })
        this.addClusterLayers(id,
          {
            type: "FeatureCollection",
            features: Stations
          }
        )
      }
    },
    // Hide Layer of Stations
    clearStationLayers() {
      // Station
      this.removeUnClusterLayers(this.l_layer_station_id, this.l_layer_station_empty_household_apdx);
      this.removeUnClusterLayers(this.l_layer_station_id, this.l_layer_station_full_household_apdx);

      // Must be removed at last because other layer using it.
      this.removeClusterLayers(this.l_layer_station_id);
    },

    // Geo Resource Function ============================
    // Add Dot Layers
    addDotLayers(name, centercolor, outercolor, data) {
      if (!this.l_mapobject) return;
      this.uniqueCompanyIds.forEach(companyId => {
        var resourceid = `${name}-company-${companyId}`;
        var pulseLayerId = resourceid + '-pulse'; // パルシングドット用のレイヤーID
        var carLayerId = resourceid + '-car';   // 車両イメージ用のレイヤーID
        var addData = data;

        if (!this.l_mapobject.getSource(resourceid)) {
          const filteredFeatures = data.features.filter(function (feature) {
            return feature.properties.companyId == companyId.toString();
          })
          addData = Object.assign({}, data, { features: filteredFeatures });
          this.l_mapobject.addSource(resourceid, {
            type: 'geojson',
            data: addData
          });
        }

        if (!this.l_mapobject.hasImage(pulseLayerId)) {
          this.l_mapobject.addImage(
            pulseLayerId,
            this.getDotMarkerImage(this.l_mapobject, centercolor, outercolor),
            { pixelRatio: 2 }
          );
        }

        const carImage = this.getCarImage(name, companyId);

        if (!this.l_mapobject.getLayer(pulseLayerId)) {
          this.l_mapobject.addLayer({
            id: pulseLayerId,
            type: 'symbol',
            source: resourceid,
            layout: {
              'icon-image': pulseLayerId,  // パルシングドット画像を指定
              'icon-allow-overlap': true,
            }
          });
        }

        if (!this.l_mapobject.getLayer(carLayerId)) {
          this.l_mapobject.addLayer({
            id: carLayerId,
            type: 'symbol',
            source: resourceid,
            layout: {
              'icon-image': carImage,
              'icon-allow-overlap': true
            }
          });
        }

        // When a click event occurs on a feature in
        // the unclustered-point layer, open a popup at
        // the location of the feature, with
        // description HTML from its properties.
        this.l_mapobject.off('click', carLayerId, this.listenVehicleClick);
        this.l_mapobject.on('click', carLayerId, this.listenVehicleClick);
      })
    },
    listenVehicleClick(e) {
      var coordinates = e.features[0].geometry.coordinates.slice();
      var vehicle = e.features[0].properties;

      // Ensure that if the map is zoomed out such that
      // multiple copies of the feature are visible, the
      // popup appears over the copy being pointed to.
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }

      var div = document.createElement('div');
      div.innerHTML = '車両ID : ' + vehicle.id + '<br>' +
        '企業名 : ' + vehicle.company + '<br>' +
        'ルートID : ' + vehicle.route + '<br>' +
        'ステータス : ' + this.getConvertedVehicleStatus(vehicle.status) + '<br>' +
        '最終更新 : ' + vehicle.timestamp;
      new maplibregl.Popup()
        .setLngLat(coordinates)
        .setDOMContent(div)
        .addTo(this.l_mapobject);
    },
    // Remove Dot Layers
    removeDotLayers(id) {
      if (!this.l_mapobject) return;

      this.uniqueCompanyIds.forEach(companyId => {
        // 各要素のID生成
        var resourceid = `${id}-company-${companyId}`;
        var pulseLayerId = resourceid + '-pulse'; // パルシングドット用のレイヤー及びイメージID
        var carLayerId = resourceid + '-car';      // 車両イメージ用のレイヤーID

        // 1. 各レイヤー（パルシングドットと車両アイコン）の削除
        if (this.l_mapobject.getLayer(pulseLayerId)) {
          this.l_mapobject.removeLayer(pulseLayerId);
        }
        if (this.l_mapobject.getLayer(carLayerId)) {
          this.l_mapobject.removeLayer(carLayerId);
        }

        // 2. クリックイベントの解除（resourceidでバインドしている場合）
        this.l_mapobject.off('click', resourceid, this.listenVehicleClick);

        // 3. GeoJSONソースの削除
        if (this.l_mapobject.getSource(resourceid)) {
          this.l_mapobject.removeSource(resourceid);
        }

        // 4. 動的に追加されたイメージ（パルシングドット）の削除
        if (this.l_mapobject.hasImage(pulseLayerId)) {
          this.l_mapobject.removeImage(pulseLayerId);
        }
      });
    },
    // Create Marker Image
    getDotMarkerImage(map, centercolorcode, outercolorcode) {
      var centercolor = this.hex2rgb(centercolorcode)
      var outercolor = this.hex2rgb(outercolorcode)
      var size = 100;
      var pulsingDot = {
        width: size,
        height: size,
        data: new Uint8Array(size * size * 4),

        // get rendering context for the map canvas when layer is added to the map
        onAdd: function () {
          var canvas = document.createElement('canvas');
          canvas.width = this.width;
          canvas.height = this.height;
          this.context = canvas.getContext('2d');
        },

        // called once before every frame where the icon will be used
        render: function () {
          var duration = 1000;
          var t = (performance.now() % duration) / duration;

          var radius = (size / 2) * 0.3;
          var outerRadius = (size / 2) * 0.7 * t + radius;
          var context = this.context;

          // draw outer circle
          context.clearRect(0, 0, this.width, this.height);
          context.beginPath();
          context.arc(
            this.width / 2,
            this.height / 2,
            outerRadius,
            0,
            Math.PI * 2
          );
          context.fillStyle = 'rgba(' + outercolor + ', ' + (1 - t) + ')';
          context.fill();

          // draw inner circle
          context.beginPath();
          context.arc(
            this.width / 2,
            this.height / 2,
            radius,
            0,
            Math.PI * 2
          );
          context.fillStyle = 'rgba(' + centercolor + ', 1)';
          context.strokeStyle = 'white';
          context.lineWidth = 2 + 4 * (1 - t);
          context.fill();
          context.stroke();

          // update this image's data with data from the canvas
          this.data = context.getImageData(
            0,
            0,
            this.width,
            this.height
          ).data;

          // continuously repaint the map, resulting in the smooth animation of the dot
          map.triggerRepaint();

          // return `true` to let the map know that the image was updated
          return true;
        }
      };
      return pulsingDot;
    },
    // Get Trash Image
    getTrashImage(status, companyId) {
      const id = companyId; // 数値型に変換
      const mapping = this.trashMapping[id];
      return mapping[status];
    },
    // Get Car Image
    getCarImage(status, companyId) {
      const id = companyId; // 数値型に変換
      const mapping = this.carMapping[id];
      return mapping[status];
    },
    // Add Cluster Layers
    addClusterLayers(id, data) {
      var layerid = id + '-clusters';
      var counterlayerid = layerid + '-count';
      var sourceid = id;

      if (this.l_mapobject.getSource(sourceid)) { }
      else {
        this.l_mapobject.addSource(sourceid, {
          type: 'geojson',
          data: data,
          cluster: true,
          clusterMaxZoom: 13, // Max zoom to cluster points on
          clusterRadius: 60 // Radius of each cluster when clustering points (defaults to 50)
        });
      }

      if (this.l_mapobject.getLayer(layerid)) { }
      else {
        this.l_mapobject.addLayer({
          id: layerid,
          type: 'circle',
          source: sourceid,
          filter: ['has', 'point_count'],
          paint: {
            // Use step expressions (https://maplibre.org/maplibre-gl-js-docs/style-spec/#expressions-step)
            // with three steps to implement three types of circles:
            //   * Blue, 20px circles when point count is less than 100
            //   * Yellow, 30px circles when point count is between 100 and 750
            //   * Pink, 40px circles when point count is greater than or equal to 750
            'circle-color': [
              'step',
              ['get', 'point_count'],
              '#51bbd6',
              100,
              '#f1f075',
              750,
              '#f28cb1'
            ],
            'circle-radius': [
              'step',
              ['get', 'point_count'],
              20,
              100,
              30,
              750,
              40
            ]
          }
        });
      }

      var font = 'Noto Sans CJK JP Regular'
      if (this.l_map_selected == 'Honeycomb_Esri_Satellite') {
        font = 'Ubuntu Regular'
      }

      if (this.l_mapobject.getLayer(counterlayerid)) { }
      else {
        this.l_mapobject.addLayer({
          id: counterlayerid,
          type: 'symbol',
          source: sourceid,
          filter: ['has', 'point_count'],
          layout: {
            'text-field': '{point_count}',
            'text-font': [font],
            'text-size': 12
          }
        });
      }

      // inspect a cluster on click
      this.l_mapobject.on('click', layerid, function (e) {
        var features = this.l_mapobject.queryRenderedFeatures(e.point, {
          layers: [layerid]
        });
        var clusterId = features[0].properties.cluster_id;
        this.l_mapobject.getSource(sourceid).getClusterExpansionZoom(
          clusterId,
          function (err, zoom) {
            if (err) return;

            this.l_mapobject.easeTo({
              center: features[0].geometry.coordinates,
              zoom: zoom
            });
          }.bind(this)
        );
      }.bind(this));
    },
    // Remove Cluster Layers
    removeClusterLayers(id) {
      if (!this.l_mapobject) return;

      const layerid = id + '-clusters';
      const counterlayerid = layerid + '-count';
      const sourceid = id;
      if (this.l_mapobject.getLayer(layerid)) {
        this.l_mapobject.removeLayer(layerid);
      }
      if (this.l_mapobject.getLayer(counterlayerid)) {
        this.l_mapobject.removeLayer(counterlayerid);
      }
      if (this.l_mapobject.getSource(sourceid)) {
        this.l_mapobject.removeSource(sourceid);
      }
    },
    addUnClusterLayers(id, data, appendixid, filter, companyId) {
      const layerid = `${id}-unclusters-${appendixid}-${companyId}`;
      const sourceid = `${id}-company-${appendixid}-${companyId}`;
      var addData = data;
      const filterdata = [
        "all",
        ['!has', 'point_count'],
      ].concat(filter);
      const image = this.getTrashImage(filter[0][2], companyId);

      // ソースの存在をチェックし、なければ新規追加
      if (!this.l_mapobject.getSource(sourceid)) {
        const filteredFeatures = data.features.filter(function (feature) {
          return feature.properties.companyId == companyId.toString();
        });
        // フィルタ済みデータを作成
        addData = Object.assign({}, data, { features: filteredFeatures });
        this.l_mapobject.addSource(sourceid, {
          type: 'geojson',
          data: addData,
          cluster: true,
          clusterMaxZoom: 13,  // クラスタリングの最大ズーム
          clusterRadius: 60    // クラスタリングする際の半径
        });
      }

      if (image != 0) {
        if (this.l_mapobject.getLayer(layerid)) {
        } else {
          this.l_mapobject.addLayer({
            id: layerid,
            type: 'symbol',
            source: sourceid,
            filter: filterdata,
            layout: {
              "icon-image": image,
              "icon-allow-overlap": true
            }
          });
        }
      } else {
        return;
      }

      // クリックイベントの設定
      this.l_mapobject.off('click', layerid, this.listenStationClick);
      this.l_mapobject.on('click', layerid, this.listenStationClick);
    },
    checkFirstToThirdWednesday() {
      // 入力が文字列の場合は ISO 8601 形式に変換して Date オブジェクトに変換
      let date;
      if (typeof this.l_lastdataupdate === 'string') {
        // "2025/04/14 13:31:38" を "2025-04-14T13:31:38" に変換
        const formattedDateString = this.l_lastdataupdate.replace(/\//g, '-').replace(' ', 'T');
        date = new Date(formattedDateString);
      } else if (this.l_lastdataupdate instanceof Date) {
        date = this.l_lastdataupdate;
      } else {
        throw new Error("無効な日付入力です。文字列または Date オブジェクトを指定してください。");
      }

      // 日付が有効かどうかチェック
      if (isNaN(date.getTime())) {
        throw new Error("無効な日付です。正しい日付形式を指定してください。");
      }

      // 水曜日かどうかチェック (JavaScriptでは、0:日～3:水～6:土)
      if (date.getDay() !== 3) {
        return 0;
      }

      // 月初から何番目の水曜日かを求める
      // ※水曜日の日付の場合、(日-1)/7 の切り捨て値 + 1 が出現回数となる
      const occurrence = Math.floor((date.getDate() - 1) / 7) + 1;

      // 第一〜第三水曜日の場合は 1 を返す
      if (occurrence >= 1 && occurrence <= 3) {
        return 1;
      } else {
        return 0;
      }
    },
    // Station Click Listener
    listenStationClick(e) {
      var coordinates = e.features[0].geometry.coordinates.slice();
      var station = e.features[0].properties;

      // Ensure that if the map is zoomed out such that
      // multiple copies of the feature are visible, the
      // popup appears over the copy being pointed to.
      while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      }
      var stationStatus = this.getConvertedStationStatus(station.type, station.status)
      // NEW-90 不法投棄 popup表示
      var comment = (!this.l_illegalValid) ?
        '管理番号 : ' + station.name + '<br>' +
        '種別 : ' + stationStatus.type + '<br>' +
        '状態 : ' + stationStatus.status + '<br>' +
        '最終更新 : ' + station.timestamp + '<br>' +
        '　　　　　' + station.timestamp2 + '<br>' +
        '　　　　　' + station.timestamp3
        :
        '管理番号 : ' + station.name + '<br>' +
        //				'最終更新 : ' + station.timestamp + '<br>' +
        '不法投棄 (' + station.freq + ' 日)<br>' +
        '　　可燃 (' + station.illegalCombustible + ' 回)<br>' +
        '　　不燃 (' + station.illegalNonburnable + ' 回)<br>' +
        '　　家電 (' + station.illegalHouseholdAppliances + ' 回)<br>' +
        '　その他 (' + station.illegalOtherGarbage + ' 回)'

      this.l_popupStation = new maplibregl.Popup()
        .setLngLat(coordinates)
        .setHTML(comment)
        .addTo(this.l_mapobject);
      this.l_popupStationId = station.id
    },
    // Remove UnCluster Layers
    removeUnClusterLayers(id, appendixid) {
      if (!this.l_mapobject) return;

      this.uniqueCompanyIds.forEach(companyId => {
        const layerid = `${id}-unclusters-${appendixid}-${companyId}`;
        const sourceid = `${id}-company-${appendixid}-${companyId}`;
        if (this.l_mapobject.getLayer(layerid)) this.l_mapobject.removeLayer(layerid);
        if (this.l_mapobject.getSource(sourceid)) this.l_mapobject.removeSource(sourceid);
      })
    },


    // GUI Handler ================================
    // Create Map Object
    mapCreate: async function (style) {
      // コンポーネントが破棄されている場合は処理を中断
      if (this.isDestroyed) {
        console.log('Component is destroyed, skipping mapCreate');
        return null;
      }
      console.log('mapCreate called with style:', style);

      // マップ作成前に認証情報を確実に取得
      if (!this.credentials) {
        try {
          this.credentials = await Auth.currentCredentials();
          console.log('Credentials fetched in mapCreate:', this.credentials);
        } catch (error) {
          console.error('Failed to fetch credentials:', error);
          // 認証情報が取得できない場合はOpenStreetMapを使用
          style = 'OpenStreetMap';
        }
      }

      // スタイルの処理
      let mapStyle = style;

      if (style === 'OpenStreetMap') {
        // OpenStreetMapのスタイル（認証不要）
        mapStyle = {
          version: 8,
          sources: {
            osm: {
              type: 'raster',
              tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
              tileSize: 256,
              attribution: '© OpenStreetMap contributors'
            }
          },
          layers: [
            {
              id: 'osm',
              type: 'raster',
              source: 'osm'
            }
          ]
        };
      } else if (typeof style === 'string' && style.trim()) {
        // Amazon Location Serviceのスタイル（認証必要）
        // styleが文字列かつ空でない場合のみ使用
        mapStyle = style;
      } else {
        console.error('Invalid map style:', style);
        mapStyle = 'OpenStreetMap'; // フォールバック
      }

      // 初期値
      var station_centerpoint = [139.754904, 35.973955];

      // Remove Old Map
      if (this.l_mapobject != null) {
        let lonlat = this.l_mapobject.getCenter();
        this.l_currentLonLat = [lonlat.lng, lonlat.lat];

        this.l_mapobject.remove();
      }

      if (this.l_currentLonLat[0] === undefined || this.l_currentLonLat[1] === undefined) {
        // Calc Fitbounds and Center Point By Station Locations
        var station_lonlatlist = this.l_stationListGeoJSON.features.map(data => data.geometry.coordinates)
        if (station_lonlatlist.length > 0) {
          var station_fitbounds = this.calculateFitBound(station_lonlatlist);
          station_centerpoint = this.calculateCenterPoint(station_fitbounds);
        }
      } else {
        station_centerpoint = this.l_currentLonLat
      }

      // DOM要素の存在確認
      const mapContainer = document.getElementById('stationmap');
      if (!mapContainer) {
        console.error('Map container "stationmap" not found. Component may have been unmounted.');
        return null;
      }

      // Loading Maps
      const map = new maplibregl.Map({
        container: 'stationmap',
        style: mapStyle,
        center: station_centerpoint,
        zoom: this.l_currentZoomLevel,
        bearing: 0,
        pitch: 0,
        transformRequest: this.transformRequest,
      });
      this.l_mapobject = map;

      // 検索機能用にmapInstanceを設定（l_mapobject作成後）
      this.mapInstance = this.l_mapobject;

      map.setZoom(this.l_currentZoomLevel)
      map.addControl(new maplibregl.NavigationControl(), "top-right");
      map.addControl(new maplibregl.FullscreenControl());

      map.once('styledata', function () {
        for (var layer of map.style.stylesheet.layers) {
          if (map.style._serializedLayers[layer.id].layout &&
            map.style._serializedLayers[layer.id].layout['text-field'] &&
            map.style._serializedLayers[layer.id].layout['text-field'] === '{_name_global}') {
            map.setLayoutProperty(layer.id, 'text-field', '{_name_local}');
          }
        }
      });

      function toggleSidebar(id) {
        var elem = document.getElementById(id);
        var classes = elem.className.split(' ');
        var collapsed = classes.indexOf('collapsed') !== -1;

        var padding = {};

        if (collapsed) {
          // Remove the 'collapsed' class from the class list of the element, this sets it back to the expanded state.
          classes.splice(classes.indexOf('collapsed'), 1);

          padding[id] = 300; // In px, matches the width of the sidebars set in .sidebar CSS class
          map.easeTo({
            padding: padding,
            duration: 1000 // In ms, CSS transition duration property for the sidebar matches this value
          });
        } else {
          padding[id] = 0;
          // Add the 'collapsed' class to the class list of the element
          classes.push('collapsed');

          map.easeTo({
            padding: padding,
            duration: 1000
          });
        }

        // Update the class list on the element
        elem.className = classes.join(' ');
      }

      map.on('zoom', function () {
        this.l_currentZoomLevel = map.getZoom();
      }.bind(this));

      map.on('move', function () {
        var lonlat = map.getCenter();
        this.l_currentLonLat = [lonlat.lng, lonlat.lat]
      }.bind(this));

      map.on('load', async function () {
        await this.fetchIllegalWasteData();
        await map.loadImage(illegal_uncollected, (error, image) => {
          if (error) throw error;
          map.addImage('illegal_uncollected', image);
        });
        await map.loadImage(illegal_collected, (error, image) => {
          if (error) throw error;
          map.addImage('illegal_collected', image);
        });
        await Promise.all(
          Object.keys(this.icons).map((key) => {
            return new Promise((resolve, reject) => {
              // icons[key] が画像のソースパスになる
              map.loadImage(this.icons[key], (error, image) => {
                if (error) {
                  reject(error);
                } else {
                  map.addImage(key, image);
                  resolve();
                }
              });
            });
          })
        );

        // 初期状態でフィルタリングを適用
        this.handlerIllegalDumpingStatus();
        this.addIllegalWasteClickListener();
        //toggleSidebar('left');
        this.viewStationStatus()

        // Show Vehicle Layers
        this.showActiveVehicleLayers();
        this.showInActiveVehicleLayers();

        // Remove Overlay
        this.l_map_overlay = false;
      }.bind(this));

      // スタイル読み込み完了を待つ
      return new Promise((resolve) => {
        map.on('style.load', () => {
          console.log('Map style loaded, ready for layer operations');
          this.showActiveVehicleLayers();
          this.showInActiveVehicleLayers();
          resolve(map);
        });

        map.on('error', (e) => {
          console.error('Map loading error:', e);
          resolve(null);
        });
      });
    },
    // Amazon Location Maps設定 (Amplify v5.3.12対応)
    transformRequest: function (url, resourceType) {
      if (resourceType === 'Style' && !url.includes('://')) {
        url = `https://maps.geo.ap-northeast-1.amazonaws.com/maps/v0/maps/${url}/style-descriptor`;
      }

      if (url.includes('amazonaws.com')) {
        if (!this.credentials) {
          return { url };
        }

        return {
          url: Signer.signUrl(url, {
            access_key: this.credentials.accessKeyId,
            secret_key: this.credentials.secretAccessKey,
            session_token: this.credentials.sessionToken,
          })
        };
      }

      return { url };
    },
    // Interface Wrapper
    // vehiclePositionRequest
    getVehicleDataWrapper() {
      const vehicleData = this.$store.getters.vehicleData;
      console.log('Vehicle data from store:', vehicleData);

      if (vehicleData && vehicleData.vehicleStatus) {
        this.updateVehicleLocation(vehicleData.vehicleStatus);
      } else {
        console.warn('Vehicle data or vehicleStatus is null/undefined, skipping update');
        // 空の配列で初期化
        this.updateVehicleLocation([]);
      }
    },
    // garbageStationStatus(0)
    getStationDataWrapper() {
      const stationData = this.$store.getters.stationData;
      console.log('Station data from store:', stationData);

      if (stationData && stationData.stStatus) {
        this.updateStationLocation(stationData.stStatus);
        // データ更新後にカウントを更新
        this.$nextTick(() => {
          this.UpdateStationCount("All");
        });
      } else {
        console.warn('Station data or stStatus is null/undefined, skipping update');
        // 空の配列で初期化
        this.updateStationLocation([]);
      }
    },
    // garbageStationStatus(0)
    getTodayStationDataWrapper() {
      this.updateStationLocationToday(this.$store.getters.todayStationData, this.$store.getters.todayStationDataLength)
    },


    // NEW-90  Interface Wrapper
    getIllegalDumpingExportRequestWrapper: async function () {
      this.l_map_overlay = true
      const vreqdata = {
        headers: {
          "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
        },
        params: {
        }
      };
      await axios.get(this.createAPI("dashboard/illegaldumpingexportrequest"), vreqdata)
        .then(response => {
          const link = document.createElement('a')
          link.href = response.data.illegalDumpingCsvURL
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(error => {
          var title = "不法投棄データ取得エラー"
          var msg = "不法投棄情報の取得に失敗しました"
          this.showErrorMessageToast(
            title,
            msg,
            'danger'
          );
        })
      this.l_map_overlay = false
    },
    getIllegalDumpingInformationRequestWrapper: async function () {
      this.l_map_overlay = true
      const vreqdata = {
        headers: {
          "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
        },
        params: {
        }
      };
      await axios.get(this.createAPI("dashboard/illegaldumpinginformationrequest"), vreqdata)
        .then(response => {
          this.l_illegalDumpingData = response.data.illegalDumpingArray
        })
        .catch(error => {
          console.log(error)
        })
      // 期間フィルター設定値に従って不法投棄データをフィルター処理
      this.l_illegalDumpingDataFilter = this.filter_byIllegalPeriod();
      // 不法投棄頻度毎のステーション数算出
      this.countIllegal_perStation();
      this.l_map_overlay = false
    },

    //春日部2nd実証実験対応:不法投棄情報
    // 受け取ったデータを処理する関数
    processIllegalWasteData(responseData) {
      const illegalWasteList = responseData.illegalWasteList;
      this.totalMarkers = illegalWasteList.length;
      this.uncollectedMarkersCount = illegalWasteList.filter(waste => !waste.collectionStatus).length;

      let filteredWasteList = illegalWasteList;
      if (this.illegalSelected === 'uncollected') {
        filteredWasteList = illegalWasteList.filter(waste => !waste.collectionStatus);
      }


      // GeoJSON形式に変換
      const geojsonData = {
        type: "FeatureCollection",
        features: filteredWasteList.map(waste => ({
          type: "Feature",
          properties: {
            illegalWasteId: waste.illegalWasteId,
            collectionStatus: waste.collectionStatus
          },
          geometry: {
            type: "Point",
            coordinates: [waste.longitude, waste.latitude]
          }
        }))
      };

      const showUncollectedOnly = this.illegalSelected === 'uncollected';
      // クラスター表示を更新
      this.addIllegalClusterLayers('illegalWaste', geojsonData, showUncollectedOnly);
    },
    toggleIllegalDumpingMarkers() {
      console.log("toggleSwitch")
      if (this.showIllegalDumpingMarkers) {
        // アイコンを表示
        this.handlerIllegalDumpingStatus();
        this.startDataFetchInterval(); // データ取得を開始
        this.fetchIllegalWasteData();
      } else {
        // アイコンを非表示
        this.hideIllegalDumpingMarkers();
        this.stopDataFetchInterval(); // データ取得を停止
      }
    },

    startDataFetchInterval() {
      if (!this.dataFetchInterval) { // すでにインターバルが設定されていない場合のみ設定
        this.dataFetchInterval = setInterval(() => {
          this.fetchIllegalWasteData();
        }, 60000); // 60000ミリ秒 = 1分
      }
    },
    stopDataFetchInterval() {
      if (this.dataFetchInterval) {
        clearInterval(this.dataFetchInterval);
        this.dataFetchInterval = null; // インターバルをリセット
      }
    },
    async fetchWasteDetails(id) {
      try {
        const vreqdata = {
          headers: {
            "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
          },
          params: {
          }
        };
        const response = await axios.get(this.createAPI(`dashboard/illegal/${id}`), vreqdata); // IDを使ってAPIを呼び出す
        const validateIllegalDetailWaste = this.validateIllegalDetailWasteData(response.data);
        if (response.status !== 200 || !validateIllegalDetailWaste) {
          throw ("Bad StatusCode:", response.status)
        }
        this.selectedWasteData = response.data; // 取得したデータを設定
        this.isModalVisible = true; // モーダルを表示
      } catch (error) {
        console.error('不法投棄情報の取得に失敗しました:', error);
        var title = "収不法投棄データ取得エラー"
        var msg = "不法投棄情報の取得に失敗しました"
        this.showErrorMessageToast(
          title,
          msg,
          'danger'
        );
      }
    },
    resetSelectedWasteData() {
      this.selectedWasteData = {}; // データをリセット
    },

    // サーバーからデータを取得する関数
    fetchIllegalWasteData: async function () {
      try {
        console.log("fetch")
        // ユーザーオブジェクトとトークンの存在確認
        const user = this.$store.getters.user;
        if (!user || !user.signInUserSession || !user.signInUserSession.idToken) {
          console.warn('User not properly authenticated, skipping illegal waste data fetch');
          return;
        }

        const reqData = {
          headers: {
            "Authorization": user.signInUserSession.idToken.jwtToken
          },
          params: {}
        };

        const response = await axios.get(this.createAPI("dashboard/illegal?timeStamp=\"\""), reqData);
        const validateIllegalWaste = this.validateIllegalWasteData(response.data)
        if (response.data || response.status !== 200) {
          this.illegalWasteData = response.data.illegalWasteList; // 取得したデータを代入
          this.processIllegalWasteData(response.data);
        } else {
          console.error('データが取得できませんでした');
        }
      } catch (error) {
        console.error('データの取得に失敗しました:', error);
        var title = "不法投棄データ取得エラー"
        var msg = "不法投棄情報の取得に失敗しました"
        this.showErrorMessageToast(
          title,
          msg,
          'danger'
        );
      }
    },
    addIllegalClusterLayers(id, data, filterUncollectedOnly) {
      const layerid = id + '-clusters';
      const counterlayerid = layerid + '-count';
      const sourceid = id;

      if (!this.l_mapobject.getSource(sourceid)) {
        this.l_mapobject.addSource(sourceid, {
          type: 'geojson',
          data: data,
          cluster: true,
          clusterMaxZoom: 14,
          clusterRadius: 50
        });
      } else {
        this.l_mapobject.getSource(sourceid).setData(data);
      }
      if (!this.l_mapobject.getLayer(layerid)) {
        this.l_mapobject.addLayer({
          id: layerid,
          type: 'circle',
          source: sourceid,
          filter: ['has', 'point_count'],
          paint: {
            'circle-color': [
              'step',
              ['get', 'point_count'],
              '#51bbd6',  // デフォルトの色
              20,
              '#f1f075', // 20以上のポイント数で使用する色
              50,
              '#f28cb1'  // 50以上のポイント数で使用する色
            ],
            'circle-radius': [
              'step',
              ['get', 'point_count'],
              15,  // デフォルトのサイズ
              20,
              20, // 20以上のポイント数で使用するサイズ
              50,
              25  // 50以上のポイント数で使用するサイズ
            ]
          }
        });
      }
      if (!this.l_mapobject.getLayer(counterlayerid)) {
        this.l_mapobject.addLayer({
          id: counterlayerid,
          type: 'symbol',
          source: sourceid,
          filter: ['has', 'point_count'],
          layout: {
            'text-field': '{point_count}',
            'text-font': ['Noto Sans CJK JP Regular'],
            'text-size': 12
          }
        });
      }

      this.l_mapobject.on('click', layerid, (e) => {
        const features = this.l_mapobject.queryRenderedFeatures(e.point, {
          layers: [layerid]
        });
        const clusterId = features[0].properties.cluster_id;

        this.l_mapobject.getSource(sourceid).getClusterExpansionZoom(
          clusterId,
          (err, zoom) => {
            if (err) {
              console.error('クラスター展開に失敗しました:', err);
              return;
            }

            this.l_mapobject.easeTo({
              center: features[0].geometry.coordinates,
              zoom: zoom
            });
          }
        );
      });

      // クラスター展開時の個別アイコン表示
      const unclusteredLayerId = id + '-unclustered';
      if (!this.l_mapobject.getLayer(unclusteredLayerId)) {

        // dataがGeoJSON形式であると仮定
        const features = data.features;
        const filterCondition = filterUncollectedOnly
          ? ['all', ['!', ['has', 'point_count']], ['==', ['get', 'collectionStatus'], false]]
          : ['!', ['has', 'point_count']];
        this.l_mapobject.addLayer({
          id: unclusteredLayerId,
          type: 'symbol',
          source: sourceid,
          filter: filterCondition,
          layout: {
            "icon-image": ["case",
              ["==", ["get", "collectionStatus"], true], "illegal_collected",
              "illegal_uncollected"
            ],
            "icon-allow-overlap": true
          }
        });
      }
    },
    handlerIllegalDumpingStatus() {
      console.log("handle1illegal")
      const geojsonData = {
        type: "FeatureCollection",
        features: this.illegalWasteData.map(waste => ({
          type: "Feature",
          properties: {
            illegalWasteId: waste.illegalWasteId,
            collectionStatus: waste.collectionStatus
          },
          geometry: {
            type: "Point",
            coordinates: [waste.longitude, waste.latitude]
          }
        }))
      };
      const unclusteredLayerId = 'illegalWaste-unclustered';
      if (this.l_mapobject.getLayer(unclusteredLayerId)) {
        this.l_mapobject.removeLayer(unclusteredLayerId);
      }

      if (this.illegalSelected === 'all') {
        // すべてのアイコンを表示
        this.addIllegalClusterLayers('illegalWaste', geojsonData, false);
      } else if (this.illegalSelected === 'uncollected') {
        // 未回収アイコンのみ表示
        const uncollectedData = {
          type: "FeatureCollection",
          features: geojsonData.features.filter(feature => !feature.properties.collectionStatus)
        };
        this.addIllegalClusterLayers('illegalWaste', uncollectedData, true);
      }
    },

    addIllegalWasteClickListener() {
      const unclusteredLayerId = 'illegalWaste-unclustered';

      // 個別アイコンのクリックイベント
      this.l_mapobject.on('click', unclusteredLayerId, async (e) => {
        const properties = e.features[0].properties;
        await this.fetchWasteDetails(properties.illegalWasteId);
      });
    },

    hideIllegalDumpingMarkers() {
      // 不法投棄アイコンを非表示にする処理
      const layerId = 'illegalWaste-unclustered';
      const clusterLayerId = 'illegalWaste-clusters';
      const clusterCountLayerId = 'illegalWaste-clusters-count';
      if (this.l_mapobject.getLayer(layerId)) {
        this.l_mapobject.removeLayer(layerId);
      }
      if (this.l_mapobject.getLayer(clusterLayerId)) {
        this.l_mapobject.removeLayer(clusterLayerId);
      }
      if (this.l_mapobject.getLayer(clusterCountLayerId)) {
        this.l_mapobject.removeLayer(clusterCountLayerId);
      }
    },
    //春日部2nd実証実験対応:収集状況
    async showModal() {
      try {
        this.l_map_overlay = true;
        await this.fetchCollectionProgress();
        this.l_map_overlay = false;
        // モーダルを表示
        this.$refs.collectionProgressModal.show();
      } catch (error) {
        this.l_map_overlay = false;
        console.error('データの取得に失敗しました:', error);
      }
      // this.$refs.collectionProgressModal.show();
    },
    async fetchCollectionProgress() {
      try {
        // WebAPIを呼び出してデータを取得
        const reqData = {
          headers: {
            "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
          },
          params: {}
        };
        const response = await axios.get(this.createAPI("dashboard/collectInfo"), reqData);

        const validateCollectionProgress = this.validateCollectionProgressData(response.data)
        if (response.status !== 200 || !validateCollectionProgress) {
          throw ("Bad StatusCode:", response.status)
        }
        this.progressData = response.data; // 取得したデータをprogressDataに格納

      } catch (error) {
        console.error('データの取得に失敗しました:', error);
        var title = "収集率データ取得エラー"
        var msg = "収集率の取得に失敗しました"
        this.showErrorMessageToast(
          title,
          msg,
          'danger'
        );
      }
    },
    async fetchUpdatedData() {
      this.isUpdating = true;
      try {
        const reqData = {
          headers: {
            "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
          },
          params: {}
        };
        const response = await axios.get(this.createAPI("dashboard/collectInfo"), reqData);
        const validateCollectionProgress = this.validateCollectionProgressData(response.data)
        if (response.status !== 200 || !validateCollectionProgress) {
          throw ("Bad StatusCode:", response.status)
        }
        // this.progressData = response.data; // 取得したデータを更新
        this.progressData = response.data; // 取得したデータをprogressDataに格納
        this.$refs.collectionProgressModal.fetchData(); // モーダルのデータを更新
      } catch (error) {
        console.error('データの取得に失敗しました:', error);
        var title = "収集率データ取得エラー"
        var msg = "収集率の取得に失敗しました"
        this.showErrorMessageToast(
          title,
          msg,
          'danger'
        );
      } finally {
        this.isUpdating = false; // 更新終了
      }
    },
    validateIllegalWasteData(data) {
      // 期待されるキーとその型を定義
      const expectedKeys = {
        illegalWasteId: 'string',
        collectionStatus: 'boolean',
        latitude: 'number',
        longitude: 'number'
      };

      // timeStampの形式を確認
      const timeStampPattern = /^\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2}$/;
      if (!data.hasOwnProperty('timeStamp') || typeof data.timeStamp !== 'string' || !timeStampPattern.test(data.timeStamp)) {
        console.error('Invalid or missing timeStamp. Expected format YYYY/MM/DD HH:MM:SS');
        return false;
      }

      // illegalWasteListが配列であるか確認
      if (!Array.isArray(data.illegalWasteList)) {
        console.error('illegalWasteList is not an array');
        return false;
      }

      // illegalWasteListが空の場合は問題なしと判定
      if (data.illegalWasteList.length === 0) {
        return true;
      }

      // 各オブジェクトを検証
      for (const item of data.illegalWasteList) {
        for (const key in expectedKeys) {
          // キーが存在するか確認
          if (!item.hasOwnProperty(key)) {
            console.error(`Missing key: ${key}`);
            return false;
          }

          // 型が期待される型であるか確認
          if (typeof item[key] !== expectedKeys[key]) {
            console.error(`Invalid type for key: ${key}. Expected ${expectedKeys[key]}, got ${typeof item[key]}`);
            return false;
          }
        }
      }

      // 全てのデータが正しい場合
      return true;
    },
    validateIllegalDetailWasteData(data) {
      const expectedSchema = {
        registrationDate: 'string',
        wasteType: 'string',
        reporter: 'string',
        discardedItem: 'string',
        quantity: 'number',
        remarks: 'string',
        lastModifiedAt: 'string',
        s3Url: 'string',
      };

      for (const key in expectedSchema) {
        if (!data.hasOwnProperty(key)) {
          console.error(`Missing key: ${key}`);
          return false;
        }
        if (typeof data[key] !== expectedSchema[key]) {
          console.error(`Invalid type for key: ${key}. Expected ${expectedSchema[key]}, got ${typeof data[key]}`);
          return false;
        }
      }

      return true;
    },
    validateCollectionProgressData(data) {
      const expectedSchema = {
        overallCollectionRate: 'number',
        combustibleDataCollectionRates: 'number',
        nonCombustibleDataCollectionRates: 'number',
        combustibleData: 'array',
        nonCombustibleData: 'array',
      };

      const districtDataSchema = {
        districtName: 'string',
        totalCount: 'number',
        collectedCount: 'number',
        districtCollectionRates: 'number',
        areaList: 'array',
        carNumberList: 'array',
      };

      // Validate top-level keys
      for (const key in expectedSchema) {
        if (!data.hasOwnProperty(key)) {
          console.error(`Missing key: ${key}`);
          return false;
        }
        if (key.endsWith('Data') && !Array.isArray(data[key])) {
          console.error(`Invalid type for key: ${key}. Expected array, got ${typeof data[key]}`);
          return false;
        }
        if (typeof data[key] !== expectedSchema[key] && !key.endsWith('Data')) {
          console.error(`Invalid type for key: ${key}. Expected ${expectedSchema[key]}, got ${typeof data[key]}`);
          return false;
        }
      }

      // Validate combustibleData array
      for (const district of data.combustibleData) {
        for (const key in districtDataSchema) {
          if (!district.hasOwnProperty(key)) {
            console.error(`Missing key in combustibleData: ${key}`);
            return false;
          }
          if ((key === 'areaList' || key === 'carNumberList') && !Array.isArray(district[key])) {
            console.error(`Invalid type for key in combustibleData: ${key}. Expected array, got ${typeof district[key]}`);
            return false;
          }
          if (typeof district[key] !== districtDataSchema[key] && key !== 'areaList' && key !== 'carNumberList') {
            console.error(`Invalid type for key in combustibleData: ${key}. Expected ${districtDataSchema[key]}, got ${typeof district[key]}`);
            return false;
          }
        }
      }

      // Validate nonCombustibleData array
      for (const district of data.nonCombustibleData) {
        for (const key in districtDataSchema) {
          if (!district.hasOwnProperty(key)) {
            console.error(`Missing key in nonCombustibleData: ${key}`);
            return false;
          }
          if ((key === 'areaList' || key === 'carNumberList') && !Array.isArray(district[key])) {
            console.error(`Invalid type for key in nonCombustibleData: ${key}. Expected array, got ${typeof district[key]}`);
            return false;
          }
          if (typeof district[key] !== districtDataSchema[key] && key !== 'areaList' && key !== 'carNumberList') {
            console.error(`Invalid type for key in nonCombustibleData: ${key}. Expected ${districtDataSchema[key]}, got ${typeof district[key]}`);
            return false;
          }
        }
      }

      return true;
    },
    async showWindow() {
      try {
        this.l_map_overlay = true;
        await this.fetchCollectionProgress();
        this.l_map_overlay = false;
        this.isCollectionProgressVisible = true;
        // フローティングウィンドウを表示
        this.$refs.collectionProgressModal.showWindow();
      } catch (error) {
        this.l_map_overlay = false;
        console.error('データの取得に失敗しました:', error);
      }
    },
    closeWindow() {
      this.isCollectionProgressVisible = false; // モーダルを閉じる際にフラグを更新
    },

    // ========== 集積所検索機能 ==========
    /**
     * 集積所選択時の処理
     * @param {Object} station - 選択された集積所データ
     */
    handleStationSelected(station) {
      // 地図の中心を集積所の位置に移動
      if (this.l_mapobject && station.lat && station.lng) {
        this.l_mapobject.flyTo({
          center: [station.lng, station.lat],
          zoom: 16,
          duration: 1000
        });
      }
    },

    /**
     * 検索実行時の処理
     * @param {Object} searchData - 検索データ（クエリ、結果、フィルター）
     */
    handleSearchPerformed(searchData) {
      // 必要に応じて、検索結果に基づいた地図の表示を更新
      // 例：検索結果のマーカーのみ表示、検索範囲にズームなど
    },

    /**
     * focus-on-locationイベントハンドラー
     * @param {Object} locationData - 位置データ（lat, lng, zoom, station）
     */
    handleFocusOnLocation(locationData) {
      if (!this.l_mapobject) {
        return;
      }

      const { lat, lng, zoom = 18, station } = locationData;

      if (!lat || !lng) {
        return;
      }

      // 既存のポップアップを削除
      if (this.l_popupStation != null) {
        this.l_popupStation.remove();
        this.l_popupStation = null;
        this.l_popupStationId = "";
      }

      // ポップアップ表示
      if (station && station.originalData) {
        setTimeout(() => {
          this.showStationPopup(lng, lat, station);
        }, 200);
      }
    },

    /**
     * 検索結果の集積所ポップアップを表示
     * @param {number} lng - 経度
     * @param {number} lat - 緯度
     * @param {Object} station - 集積所データ
     */
    showStationPopup(lng, lat, station) {
      // 地図の移動が完了するまで待機してからポップアップを表示
      const displayPopup = () => {
        try {
          // 地図上の指定座標でクリックイベントを擬似的に実行
          const point = this.l_mapobject.project([lng, lat]);

          // 指定座標の集積所レイヤーを検索
          const features = this.l_mapobject.queryRenderedFeatures(point);

          // 管理番号が一致する集積所フィーチャーを探す
          const targetFeature = features.find(feature => {
            return feature.properties &&
                   feature.properties.name &&
                   feature.properties.name.toString() === station.managementNumber.toString() &&
                   feature.source &&
                   feature.source.includes('station'); // 集積所レイヤーかどうかをチェック
          });

          if (targetFeature) {
            // 擬似的なクリックイベントオブジェクトを作成
            const mockClickEvent = {
              features: [targetFeature],
              lngLat: { lng: lng, lat: lat }
            };

            // listenStationClickメソッドを直接呼び出し
            this.listenStationClick(mockClickEvent);
            return;
          }

          // 地図上で見つからない場合は、周辺をより広く検索
          const bbox = [
            [lng - 0.0005, lat - 0.0005],
            [lng + 0.0005, lat + 0.0005]
          ];

          const nearbyFeatures = this.l_mapobject.queryRenderedFeatures(bbox);
          const nearbyTarget = nearbyFeatures.find(feature => {
            return feature.properties &&
                   feature.properties.name &&
                   feature.properties.name.toString() === station.managementNumber.toString() &&
                   feature.source &&
                   feature.source.includes('station');
          });

          if (nearbyTarget) {
            const mockClickEvent = {
              features: [nearbyTarget],
              lngLat: { lng: lng, lat: lat }
            };
            this.listenStationClick(mockClickEvent);
            return;
          }

          console.warn('地図上に該当する集積所フィーチャーが見つかりません:', station.managementNumber);

          // どうしても見つからない場合は、最低限の情報でポップアップを表示
          const comment = `管理番号 : ${station.managementNumber}<br>この集積所は表示フィルタで非表示になっております。<br>詳細情報の確認は、表示フィルタを全て表示に設定した上で、再度検索をお願いします。`;
          this.l_popupStation = new maplibregl.Popup()
            .setLngLat([lng, lat])
            .setHTML(comment)
            .addTo(this.l_mapobject);

        } catch (error) {
          console.error('ポップアップ表示エラー:', error);

          // エラー時は最小限の情報でポップアップを表示
          const fallbackComment = `管理番号 : ${station.managementNumber || 'N/A'}<br>※エラーが発生しました`;
          this.l_popupStation = new maplibregl.Popup()
            .setLngLat([lng, lat])
            .setHTML(fallbackComment)
            .addTo(this.l_mapobject);
        }
      };

      // 地図の移動状態をチェック
      if (this.l_mapobject.isMoving()) {
        // 地図が移動中の場合は、移動完了を待つ
        this.l_mapobject.once('moveend', () => {
          // さらに少し待ってからポップアップを表示
          setTimeout(displayPopup, 200);
        });
      } else {
        // 地図が静止している場合は、少し待ってからポップアップを表示
        setTimeout(displayPopup, 100);
      }
    },    /**
     * 集積所レイヤーIDの配列を取得
     */
    getStationLayerIds() {
      const layerIds = [];
      const baseLayerTypes = ['household', 'recycle'];

      baseLayerTypes.forEach(type => {
        this.uniqueCompanyIds.forEach(companyId => {
          layerIds.push(`${this.l_layer_station_id}-unclusters-${type}-${companyId}`);
        });
      });

      return layerIds;
    },    /**
     * 集積所にフォーカス（検索機能から呼び出される）
     * @param {number} lat - 緯度
     * @param {number} lng - 経度
     * @param {number} stationId - 集積所ID
     */
    focusOnStation(lat, lng, stationId) {
      if (this.l_mapobject) {
        this.l_mapobject.flyTo({
          center: [lng, lat],
          zoom: 17,
          duration: 1500
        });

        // 集積所マーカーをハイライト（可能であれば）
      }
    }

  }

}
</script>

<style scoped>
#stationmap {
  z-index: 0;
  height: calc(100vh - 5rem);
}
.rounded-rect {
  background: white;
  border-radius: 10px;
  box-shadow: 0 0 50px -25px black;
}

.flex-center {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-center.left {
  left: 0px;
}

.sidebar-content {
  position: absolute;
  width: 95%;
  height: 98%;
  font-family: 'Noto Sans JP', sans-serif;
  -webkit-font-smoothing: subpixel-antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow-y: auto;
  /* スクロールバーを表示する */
}

.sidebar {
  transition: transform 1s;
  z-index: 1;
  width: 280px;
  height: 100%;
}

.mt-1 {
  margin-bottom: .5rem;
}

.list-group {
  height: calc(100vh - 11rem);
  overflow-y: auto;
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #fff;
  border: none;
  border-radius: 10px;
  box-shadow: inset 0 0 2px #777;
}

::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
  box-shadow: none;
}

/* テーブルとセルの境界線（全体を白の1pxボーダーに統一） */
.table-bordered,
.table-bordered th,
.table-bordered td,
.table th,
.table td {
  border: 1px solid #ffffff !important;
}

.table {
  font-size: 14px;
}

.table td img {
  display: block;
  margin: 0 auto;
}

.table td.company-name {
  padding-left: 10px;
}

/* table要素の基本スタイル */
table {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  text-indent: initial;
  unicode-bidi: isolate;
  border-spacing: 1px;
  border-color: #ffffff;
}

/* 全tr要素のボーダーカラー設定 */
tr {
  border-color: #ffffff;
}

/* 各グループの背景色設定 */
.group-household tr {
  background-color: #e6f7ff;
}

.group-other tr {
  background-color: #f8f7d0;
}

/* 各グループの最初の行に対する特別なスタイル */
.group-household>tr:first-child {
  text-align: center;
  background-color: #cceeff;
}

.group-other>tr:first-child {
  text-align: center;
  background-color: #ffe9a2;
}

/* スペーサー用tbodyのtdスタイル */
tbody.spacer td {
  border: none;
  height: 10px;
  background-color: #ffffff;
  padding: 0;
}

.spacer {
  margin-top: 10px;
  /* ここでスペースの量を調整 */
}

/* カスタムオーバーレイスピナー */
.overlay-spinner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  border-radius: 0.25rem;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}
</style>
